export function faq() {

    const faqBlock = document.querySelector('.js-faqBlock');
    if (!faqBlock) {
        return false;
    }

    const formData = new FormData();
    formData.append('pathname', location.pathname);

    if(!faqBlock) {
        return false;
    }

    // Ajax
    fetch('/popular_questions', {
        method: 'POST',
        body: formData,
        headers: {
            'X-Requested-With': 'XMLHttpRequest',
        },
    })
    .then(response => response.json())
    .then(r => {
        if (r.status == 'ok' && r.render != '') {
            faqBlock.innerHTML = r.render
        }
    })
    .then(() => {
        const faqElem = document.querySelectorAll('.js-faq');
        const showAll = document.querySelector('.js-faqShow');
        const faqWrapper = document.querySelector('.js-faqWrapper');

        if (!faqElem) {
            return false;
        }

        faqElem.forEach( item => {
            item.addEventListener('click', function() {
                this.classList.toggle('is-active');
            });
        });

        if (!showAll) {
            return false;
        }

        showAll.addEventListener('click', function() {
            if (document.querySelectorAll('.js-faq.js-hiddenFaq').length <= 3) {
                showAll.remove();
            }
            let count = 3;

            document.querySelectorAll('.js-faq.js-hiddenFaq').forEach(el => {
                if (count > 0) {
                    el.style.display = 'block';
                    el.classList.remove('js-hiddenFaq');
                }
                count--
            });
        });
    })
}